module.exports = __webpack_public_path__ + "img/map.90c679bb.jpg";